require('./js/odetManager');



// WEBPACK FOOTER //
// ./web/js/module/vsko-odet-manager/index.js